import * as React from 'react'
import { useAudio } from 'react-use'

const defaultState = {
  isPaused: true,
  isMuted: false,
  play: () => {},
  pause: () => {},
  seek: () => {},
  toggleMute: () => {},
  audioRef: null,
  time: 0,
  duration: 0,
  loop: false,
}

interface IContextProps {
  isPaused: boolean
  isMuted: boolean
  play: () => void
  pause: () => void
  seek: (time: number) => void
  toggleMute: () => void
  audioRef: any
  time: number
  duration: number
  loop?: boolean
}

const AudioContext = React.createContext<IContextProps>(defaultState)

const AudioProvider: React.FC<ProviderProps> = ({ children, src, loop }) => {
  const [audio, state, controls, ref] = useAudio({
    src,
    autoPlay: false,
    preload: 'auto',
    loop,
  })
  function toggleMute() {
    if (state.muted) {
      controls.unmute()
    } else {
      controls.mute()
    }
  }
  return (
    <AudioContext.Provider
      value={{
        isPaused: state.paused,
        isMuted: state.muted,
        play: controls.play,
        pause: controls.pause,
        seek: controls.seek,
        toggleMute,
        audioRef: src ? ref : null,
        time: state.time,
        duration: state.duration,
        loop,
      }}
    >
      {children}
      {src ? audio : null}
    </AudioContext.Provider>
  )
}

export default AudioContext

export { AudioProvider }

type ProviderProps = {
  src: string
  loop?: boolean
}
